let level = -1
const levels = {
  debug: 3,
  info: 2,
  warn: 1,
  error: 0,
  none: -1
}

export default class Log {
  static setLevel(newLevel) {
    if (typeof newLevel === 'string') {
      level = levels[newLevel]
    } else {
      level = newLevel
    }
  }

  static debug(...args) {
    if (level < levels.debug) {
      return
    }
    for (const arg of args) {
      if (typeof arg === 'object') {
        console.log('[Noci]', arg)
      } else {
        console.log(`[Noci] ${arg}`)
      }
    }
  }

  static info(...args) {
    if (level < levels.info) {
      return
    }
    for (const arg of args) {
      if (typeof arg === 'object') {
        console.log('%c[Noci]', 'color: #9e9e9e', arg)
      } else {
        console.log(`%c[Noci] ${arg}`, 'color: #9e9e9e')
      }
    }
  }

  static warn(...args) {
    if (level < levels.warn) {
      return
    }
    for (const arg of args) {
      if (typeof arg === 'object') {
        console.log('%c[Noci]', 'color: #fb8c00', arg)
      } else {
        console.log(`%c[Noci] ${arg}`, 'color: #fb8c00')
      }
    }
  }

  static error(...args) {
    if (level < levels.error) {
      return
    }
    for (const arg of args) {
      if (typeof arg === 'object') {
        console.log('%c[Noci]', 'color: #d32f2f', arg)
      } else {
        console.log(`%c[Noci] ${arg}`, 'color: #d32f2f')
      }
    }
  }
}
